import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CareerPlanResource } from 'src/app/models/career-plans';
import { Util } from 'src/app/util';

@Component({
  selector: 'app-resource-card',
  templateUrl: './resource-card.component.html',
  styleUrls: ['./resource-card.component.scss'],
})
export class ResourceCardComponent implements OnInit {
  @Input()
  resource: CareerPlanResource;

  coverUrl: string;

  constructor(private router: Router) {}

  ngOnInit() {
    this.coverUrl = this.resource.coverUrl == null ? 'assets/cover.jpg' : this.resource.coverUrl;
  }

  navigateToResource() {
    this.router.navigate(['/info', Util.slugify(this.resource.title) + '-' + this.resource.recordId]);
  }

  get completionLabelKey(): string {
    return this.resource.progress >= 85 ? 'careerPlans.status.completed' : 'careerPlans.status.checking';
  }
}
